<template>
  <el-form
    :model="formData"
    :rules="rules"
    ref="ruleForm"
    label-width="0px"
    size="medium"
  >
    <el-form-item prop="phone">
      <el-row>
        <el-col :span="16">
          <el-input v-model="formData.phone" disabled></el-input>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-button
            class="verifiy-btn"
            @click.prevent="getVerifiyCode"
            :disabled="!!countDown"
            :class="{ red: countDown }"
            >{{ countDown ? `${verifiyText}s` : verifiyText }}</el-button
          >
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item prop="signCode">
      <el-input
        v-model="formData.signCode"
        placeholder="请输入验证码"
      ></el-input>
    </el-form-item>
    <el-button type="primary" @click="onSubmit" class="submit-btn" size="medium"
      >确定</el-button
    >
  </el-form>
</template>

<script>
import { sendSignCode, sureNotify } from "@/api/api";

export default {
  props: {
    formConfig: Object
  },
  data() {
    return {
      formData: {
        id: '',
        phone: "",
        signCode: "",
      },
      verifiyText: "获取验证码",
      countDown: null,
      rules: {
        signCode: [
          { required: true, message: "请填写验证码", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.formData = {
      id: this.formConfig.row.id,
      phone: this.formConfig.row.phone,
      signCode: ''
    }
  },
  methods: {
    getVerifiyCode() {
      if (this.countDown) {
        return false;
      }
      this.verifiyText = 60;

      this.countDown = setInterval(() => {
        console.log(this.verifiyText);
        this.verifiyText -= 1;
        if (this.verifiyText === 0) {
          this.clearTimeFn();
        }
      }, 1000);
      sendSignCode(this.formData).then(res => {
        if (!res.success) {
          this.clearTimeFn();
        }
      }).catch(() => {
        this.clearTimeFn();
      })

    },
    clearTimeFn() {
      clearInterval(this.countDown);
      this.countDown = null;
      this.verifiyText = "重新获取验证码";
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          sureNotify(this.formData).then(res => {
            if (res.success) {
              this.$emit("getList");
              this.$emit("close");
            }
            this.clearTimeFn();
          }).catch(() => {
            this.clearTimeFn();
          })
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.verifiy-btn {
  width: 100%;

  &.red {
    color: red;
  }
}

.submit-btn {
  width: 100%;
  margin-top: 20px;
}
</style>
